import React from 'react';
import ImageGallery from 'react-image-gallery';
import "react-image-gallery/styles/css/image-gallery.css";

export default class SlideAdm extends React.Component {
    render() {
        const images = [
            {
                original: process.env.PUBLIC_URL + '/slides/adm1.jpg',
                thumbnail: process.env.PUBLIC_URL + '/slides/adm1.jpg',
            },
            {
                original: process.env.PUBLIC_URL + '/slides/adm2.jpg',
                thumbnail: process.env.PUBLIC_URL + '/slides/adm2.jpg',
            },
            {
                original: process.env.PUBLIC_URL + '/slides/adm3.jpg',
                thumbnail: process.env.PUBLIC_URL + '/slides/adm3.jpg',
            },
            {
                original: process.env.PUBLIC_URL + '/slides/adm4.jpg',
                thumbnail: process.env.PUBLIC_URL + '/slides/adm4.jpg',
            },
            {
                original: process.env.PUBLIC_URL + '/slides/adm5.jpg',
                thumbnail: process.env.PUBLIC_URL + '/slides/adm5.jpg',
            },
            {
                original: process.env.PUBLIC_URL + '/slides/adm6.jpg',
                thumbnail: process.env.PUBLIC_URL + '/slides/adm6.jpg',
            },
            {
                original: process.env.PUBLIC_URL + '/slides/adm7.jpg',
                thumbnail: process.env.PUBLIC_URL + '/slides/adm7.jpg',
            },
            {
                original: process.env.PUBLIC_URL + '/slides/adm8.jpg',
                thumbnail: process.env.PUBLIC_URL + '/slides/adm8.jpg',
            },
            {
                original: process.env.PUBLIC_URL + '/slides/adm9.jpg',
                thumbnail: process.env.PUBLIC_URL + '/slides/adm9.jpg',
            },
            {
                original: process.env.PUBLIC_URL + '/slides/adm10.jpg',
                thumbnail: process.env.PUBLIC_URL + '/slides/adm10.jpg',
            }
        ]
        return (

                <>


                <section className="page-section portfolio" id="painel">
                    <div className="container">

                    <h2 className="page-section-heading text-center text-uppercase text-secondary mb-0">Painel Administrativo</h2>

                    <div className="divider-custom">
                        <div className="divider-custom-line"></div>
                        <div className="divider-custom-icon">
                        <i className="fa fa-star"></i>
                        </div>
                        <div className="divider-custom-line"></div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                        <ImageGallery items={images} autoPlay={true} />
                        </div>
                        <div className="col-md-6 p-3">
                        <h2>O que vamos encontrar aqui?</h2>
                        <p>No painel do administrador, vamos encontrar o cadastro dos produtos, categorias, banners, visualizar os pedidos recebidos, etc.</p>
                        <ol className="ml-3">
                            <li>Áreas, grupos e subgrupos</li>
                            <li>Fabricantes</li>
                            <li>Verificação de erros de cadastro</li>
                        </ol>
                        <h4>Ná área clientes, o administrador tem os dados dos clientes, parceiros, depoimentos dos compradores, banners, cupons de desconto, etc.</h4>
                        </div>
                    </div>

                    </div>

                </section>

                </>

        );
    }
}